import {combineReducers} from 'redux';

import * as actionTypes from './actionTypes';

const initialState = {
    userGroups: null,
    searchGroups: null,
    inviteDetails: []
};

const inviteDetails = (state = initialState.inviteDetails, action) => {
    switch (action.type){
        case actionTypes.ADD_NEW_INVITE:
            return action.groups;
        case actionTypes.DELETE_INVITE:
            const index = state.findIndex(x => x.id === action.group.id);
            const aux = [...state];
            aux.splice(index, 1);
            return aux;
        default:
            return state;
    }
}

const userGroups = (state = initialState.userGroups, action) => {
    switch (action.type) {
        case actionTypes.LOADED_USER_GROUPS:
            return {
                groups: [...action.userGroups],
                askedGroups: [...action.askedGroups],
                groupInvites: [...action.groupInvites]
            };
        case actionTypes.ADDED_USER_GROUP:
            return {
                groups: [...state.groups, action.group].sort((a, b) => b.joinedUsers - a.joinedUsers),
                askedGroups: state.askedGroups,
                groupInvites: state.groupInvites
            }
        case actionTypes.REMOVED_USER_GROUP:
            return {
                groups: [...state.groups].filter(x => x.id !== action.id),
                askedGroups: state.askedGroups,
                groupInvites: state.groupInvites
            }
        case actionTypes.ASKED_NEW_GROUP:
            return {
                groups: state.groups,
                askedGroups: [...state.askedGroups, action.askedGroup.id],
                groupInvites: state.groupInvites
            }
        case actionTypes.UPDATE_LOADED_GROUP:
            if(!state){
                return state;
            }
            const aux = [...state.groups];
            const index = aux.findIndex(x => x.id === action.group.id);
            if(index !== -1){
                aux[index] = action.group;
            }
            return {
                groups: aux.sort((a, b) => b.joinedUsers - a.joinedUsers),
                askedGroups: state.askedGroups,
                groupInvites: state.groupInvites
            }
        case actionTypes.DELETE_INVITE:
            return {
                groups: state.groups,
                askedGroups: state.askedGroups,
                groupInvites: [...state.groupInvites].filter(x => x !== action.group.id)
            }
        case actionTypes.DELETED_GROUP:
            return {
                groups: [...state.groups].filter(x => x.id !== action.group.id),
                askedGroups: state.askedGroups,
                groupInvites: state.groupInvites
            }
        default:
            return state;

    }
}

const searchGroups = (state = initialState.searchGroups, action) => {
    switch (action.type){
        case actionTypes.LOADED_GROUP_SEARCH:
            return action.data;
        case actionTypes.NEW_PAGE_GROUP_SEARCH:
            return {...action.data, groups: [...state.groups, ...action.data.groups] }
        case actionTypes.UPDATE_SEARCHED_GROUP:
            if(!state){
                return state;
            }
            const index = state.groups.findIndex(x => x.id === action.group.id);
            state.groups[index] = action.group;
            return state;
        default:
            return state;
    }
}

const reducer = combineReducers({
    userGroups,
    searchGroups,
    inviteDetails
});

export default reducer;
